import api from ".";

export const estornar = (lancamentos) => api.post("/lancamentoBaixa/estornar", lancamentos);

export const listar = (start, size, filters, filtersMode, globalFilter, sorting, tipo, uuid) => api.get(`/lancamentoBaixa/listar/`, {
    params: { start, size, filters, filtersMode, globalFilter, sorting , tipo, uuid}
})
